// Shared modules are discovered from src/modules/<name>/index.js.
// Templates pick from these via `modules` / `exclude` in their index.js.
const context = require.context('.', true, /^\.\/[\w-]+\/index\.js$/);

export default context.keys()
    .filter(key => key.startsWith('./'))
    .map(key => context(key).default);
